import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { UserManager, UserManagerSettings, User, WebStorageStateStore } from 'oidc-client';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { BaseService } from '../../base/services/base.service';
import { ConfigService } from '../../base/services/config.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';


//import * as jwt_decode from 'jwt-decode';
export interface ReportAuth {
    status: string;
    origen: string;
    user: User | null;

}
@Injectable({
    providedIn: 'root'
})
export class AuthService extends BaseService {

    // Observable navItem source
    private _authNavStatusSource = new BehaviorSubject<ReportAuth>({ status: "pendient", origen: "clase", user: null });
    // Observable navItem stream
    //authNavStatus$ = this._authNavStatusSource.asObservable();

    get authNavStatus$(): Observable<ReportAuth> {
        return this._authNavStatusSource.asObservable();
    }

    //Login
    // Observable navItem source
    private _authNavStatusSourceLogin = new BehaviorSubject<ReportAuth>({ status: "pendient", origen: "clase", user: null });
    // Observable navItem stream
    authNavStatusLogin$ = this._authNavStatusSourceLogin.asObservable();

    private manager = new UserManager(getClientSettings(this.appConfigService));
    private user: User | null;

    public userName: string;


    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private appConfigService: AppConfigService
    ) {
        super();

        this.manager.getUser().then(user => {

            this.user = user;
            this._authNavStatusSource.next({ status: this.isAuthenticated(), origen: "constructor", user: this.user });

        });

		this.manager.events.addSilentRenewError(function (error: Error) {
			// custom logic here
			console.error('SilentRenewError');
			console.error(error);
		});

		/*this.manager.startSilentRenew();
		this.manager.signinSilent();
		this.manager.stopSilentRenew();*/

	}

    notificarAuth(notif: ReportAuth) {
        this._authNavStatusSource.next(notif);
    }

	signinSilent() {
		return this.manager.signinSilent()
			.then(user => {
				console.log('signinSilent');
				alert(JSON.stringify(user));
				this.user = user;
				this._authNavStatusSource.next({ status: this.isAuthenticated(), origen: "constructor", user: this.user });
			})
			.catch(err => {
				console.error('signinSilent');
				console.error(err);
				this.manager.getUser().then(user => {
					this.user = user;
					this._authNavStatusSource.next({ status: this.isAuthenticated(), origen: "constructor", user: this.user });
				});
			});
	}

	login() {
		return this.manager.signinRedirect();
	}

    async completeAuthentication() {
        this.user = await this.manager.signinRedirectCallback();
        this._authNavStatusSource.next({ status: this.isAuthenticated(), origen: "completeAuth", user: this.user });
    }

    async completeLogout() {
        this._authNavStatusSource.next({ status: "false", origen: "completeLogout", user: null });
    }

    register(userRegistration: any) {
        return this.http.post(this.configService.authApiURI + '/account', userRegistration).pipe(catchError(this.handleError));
    }

    isAuthenticated(): string {
        return (this.user != null && !this.user.expired) ? "true" : "false";
    }


    public isAuthenticatedAsync(): Observable<boolean> {
        return from(this.manager.getUser()).pipe(map(u => !!u));
    }


    hasRoleInUser(user: User, role: string): boolean {
        let roles = role.split(',').map(item => item.trim()), roleCount = 0;
        roles.forEach((role)=>{
            roleCount += this.hasRole(role) ? 1 : 0;
        });
        return roleCount > 0;
    }

    anyRole(): boolean {
        if (this.user.profile.role == null || this.user.profile.role == undefined) return false;
        return this.user.profile.role.length > 0;
    }

    hasRole(role: string): boolean {
        if (this.user.profile.role == null || this.user.profile.role == undefined) return false;
        return this.user.profile.role.indexOf(role) >= 0;

    }

    hasRoleStartingWith(prefix: string): boolean {
        const role = this.user && this.user.profile ? this.user.profile.role : null;
        if (role == null || role == undefined) return false;
        const roles: string[] = Array.isArray(role) ? role : [role];
        return roles.some(r => r.startsWith(prefix));
    }

    get authorizationHeaderValue(): string {
        return `${this.user.token_type} ${this.user.access_token}`;
    }

    get name(): string {
        if (this.isAuthenticated() == "true") return this.user.profile.name;
        else return '';
    }

    get email(): string {
        if (this.isAuthenticated() == "true") return this.user.profile.email;
        else return '';
    }

    get givenNameAsync(): Observable<string> {
        return from(this.manager.getUser()).pipe(map(u => u.profile.given_name));
    }

    signout() {
        this.manager.signoutRedirect();
    }

    //Promise
    public getUser(): Promise<User> {
        return this.manager.getUser();
    }

    public login2(): Promise<void> {
        return this.manager.signinRedirect();
    }

    public renewToken(): Promise<User> {
        return this.manager.signinSilent();
    }

    public logout(): Promise<void> {
        return this.manager.signoutRedirect();
    }

    public AuthUrl(url:string):string{
        return `${url}?access-token=${this.user.access_token}`;
	}

	
}

export function getClientSettings(appConfigService: AppConfigService): UserManagerSettings {
    const appName = appConfigService.BaseUrl.split("/").filter(t => t).pop();
    let OicUrl: string = appConfigService.OicDynamic ? appConfigService.BaseUrl.replace(appName, appConfigService.OicUrl) : `${appConfigService.OicUrl}/`;
    return {
        authority: OicUrl,
        client_id: appConfigService.ClientId,
        redirect_uri: `${appConfigService.BaseUrl}auth-callback`,
        post_logout_redirect_uri: `${appConfigService.BaseUrl}logout-callback`,
        response_type: "id_token token",
        scope: `openid profile email ${appConfigService.Scope}`,
        filterProtocolClaims: true,
        loadUserInfo: true,
		automaticSilentRenew: true,
		includeIdTokenInSilentRenew:true,
		silent_redirect_uri: `${appConfigService.BaseUrl}silent-refresh.html` 
    };
}
